import type { HelpFile } from '../../types/help'
import { ApprovalPolicyFormTestIds } from '../../../testids/ApprovalPolicyFormTestIds'

export const approvalPolicyFormHelp: HelpFile = {
  docPage: '/docs/governance/approval-policies',
  texts: {
    [ApprovalPolicyFormTestIds.btnAddCondition]:
      'Add a new condition to determine when this approval policy applies.',
    [ApprovalPolicyFormTestIds.btnAddStep]:
      'Add a new approval step. Each step defines who must approve at that stage.',
    [ApprovalPolicyFormTestIds.btnCancel]: null,
    [ApprovalPolicyFormTestIds.btnSubmit]: null,
    [ApprovalPolicyFormTestIds.cardTitleConditions]:
      'Conditions that must all match for this policy to apply — add one per filter criterion.',
    [ApprovalPolicyFormTestIds.cardTitleSteps]:
      'Ordered approver chain — each step runs in sequence and must be resolved before the next begins.',
    [ApprovalPolicyFormTestIds.inputName]: null,
    [ApprovalPolicyFormTestIds.inputDescription]: null,
    [ApprovalPolicyFormTestIds.inputPriority]:
      'Lower number wins when multiple policies match the same request.',
    [ApprovalPolicyFormTestIds.policyTypeReadonly]:
      'Policy type is fixed after creation — it determines which request types this policy can match.',
    [ApprovalPolicyFormTestIds.selectApprovalStrategy]:
      'How decisions are aggregated within this step — single approver, all required, or any one of the resolved approvers.',
    [ApprovalPolicyFormTestIds.selectConditionField]:
      'Request attribute this condition evaluates — for example access profile or target system.',
    [ApprovalPolicyFormTestIds.selectConditionOperator]:
      'Comparison operator applied to the field — equals, in, starts with, etc.',
    [ApprovalPolicyFormTestIds.selectPolicyType]:
      'Request type this policy can match — determines which condition fields are available.',
    [ApprovalPolicyFormTestIds.selectResolverType]:
      'How approvers for this step are resolved — fixed identity, role, manager of requester, etc.',
  },
}
